import React from 'react'
import { LoadingContent, ShowIf, Switch } from '@ztechapps/webui.util'
import { useCheckoutContext } from '../index'

export const CheckoutPanels = () => {
  const context = useCheckoutContext()

  const [activePanel] = context.activePanel
  const checkoutSteps = context.checkoutSteps
  const { loading } = context.orderDocumentResult

  return checkoutSteps.map(({ panel: Panel, itemKey }) => (
    <React.Fragment key={itemKey}>
      <ShowIf condition={activePanel === itemKey}>
        <Switch expression={loading}>
          {{
            true: <LoadingContent />,
            false: <Panel />,
          }}
        </Switch>
      </ShowIf>
    </React.Fragment>
  ))
}
